module.exports = __webpack_public_path__ + "media/images/admin2/AdminDashboardIndex__table__col__header-9a38af37dfba096b71d12e4374a310bc.svg";